import { FC } from "react";
import EditAlbum from "@components/Home/AlbumRoutes/EditAlbum/EditAlbum";
import { useNavigate, useParams } from "react-router-dom";
import { useGetAlbumQuery } from "@store/albumApi";
import { Box } from "@mui/material";
import TextIconButton from "@components/TextIconButton";
import { useTranslation } from "react-i18next";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const EditAlbumPage: FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { data: album } = useGetAlbumQuery({ id: id! }, { skip: !id });

  const goBack = () => {
    navigate("../");
  };

  return (
    <>
      <Box marginBottom="32px">
        <TextIconButton
          onClick={goBack}
          text={t("backButton")}
          icon={ArrowBackIcon}
          variant="text"
          iconLeft={true}
        />
      </Box>
      <EditAlbum album={album} onSaved={goBack} />
    </>
  );
};

export default EditAlbumPage;
